<script lang="ts">
  import { link } from "svelte-spa-router";
  import { Container, Row } from "sveltestrap";
  import { appName, mailAddress } from "../stores";
</script>

<footer class="text-center text-white pt-4 pt-md-5 border-top">
  <Container>
    <Row>
      <div class="col-12 col-sm left-aligned">
        <div class="d-flex align-items-center">
          <img
            class="mb-2 d-inline-block"
            src="images/logo.png"
            alt="logo"
            width="35"
            height="35"
          />
          <h2 class="title">&nbsp;&nbsp;&nbsp; {$appName}</h2>
        </div>
        <p class="text-muted subtitle">
          Use your Unity Cloud setup to run automated tests on Pull Requests
        </p>
        <small class="d-block mb-3 text-muted">
          © 2021 All rights reserved
        </small>
      </div>

      <div class="col-6 col-sm" />
      <div class="col-6 col-sm left-aligned">
        <h5>Information</h5>
        <ul class="list-unstyled text-small">
          <li><a href="/docs">Docs</a></li>
          <li><a href="/pricing" use:link>Pricing</a></li>
          <li><a href="/generator">Config generator</a></li>
          <li><a href="mailto:{$mailAddress}">Contact Us</a></li>
        </ul>
      </div>

      <div class="col-6 col-sm left-aligned">
        <h5>Legal</h5>

        <ul class="list-unstyled text-small">
          <li>
            <a href="/policy/terms-of-service" use:link>Terms of Service</a>
          </li>
          <li><a href="/policy/privacy-policy" use:link>Privacy Policy</a></li>
          <li><a href="/policy/subprocessors" use:link>Subprocessors</a></li>
        </ul>
      </div>
    </Row>
  </Container>
</footer>

<style>
  footer {
    padding: 80px 0px;
    width: 100%;
    margin: 0px auto;
    background-color: #181a18;
  }

  h5 {
    font-family: Rubik;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    text-transform: capitalize;
    font-feature-settings: "liga" off;
  }

  a {
    background-color: transparent;
    color: #ffffff;
    text-decoration: none;
    text-align: left;
  }

  a:hover {
    color: #0056b3;
    text-decoration: underline;
  }

  h2.title {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 15.2782px;
    line-height: 19px;
    text-align: right;
  }

  .left-aligned {
    text-align: left;
  }

  .left-aligned h5 {
    padding-bottom: 20px;
  }

  li {
    padding-top: 5px;
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
  }

  .subtitle {
    text-align: left;
    max-width: 230px;
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 184%;
  }
</style>
